class Message {
    id;
    playerId;
    playerName;
    createdAt;
    message;

    constructor(id, playerId, playerName, createdAt, message) {
        this.id = id;
        this.playerId = playerId;
        this.playerName = playerName;
        this.createdAt = createdAt;
        this.message = message;
    }
}

export default Message;
